import React from "react";
import { Modal, Button } from "react-bootstrap";

const SendReportModal = ({ show, onClose, message }) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
            dialogClassName="send-report-modal modal-dialog-centered"
        >
            <Modal.Header closeButton>
                <Modal.Title>Send Report</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SendReportModal;
